/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseSectionPanelAldrinFragment} from '@amblique/contentful/app/contentful/fragments/section-panel-aldrin/base-section-panel-aldrin.fragment';
import {AccordionFragment} from '@amblique/contentful/app/contentful/fragments/accordion/accordion.fragment';
import {AccordionPanelFragment} from '@amblique/contentful/app/contentful/fragments/accordion-panel/accordion-panel.fragment';
import {ActionLinksFragment} from '@amblique/contentful/app/contentful/fragments/action-links/action-links.fragment';
import {CarouselFragment} from '@amblique/contentful/app/contentful/fragments/carousel/carousel.fragment';
import {ContainerFragment} from '@amblique/contentful/app/contentful/fragments/container/container.fragment';
import {EmbedPanelFragment} from '@amblique/contentful/app/contentful/fragments/embed-panel/embed-panel.fragment';
import {FeatureListFragment} from '@amblique/contentful/app/contentful/fragments/feature-list/feature-list.fragment';
import {HeroBannerFragment} from '@amblique/contentful/app/contentful/fragments/hero-banner/hero-banner.fragment';
import {ImageFragment} from '@amblique/contentful/app/contentful/fragments/image/image.fragment';
import {LinkFragment} from '@amblique/contentful/app/contentful/fragments/link/link.fragment';
import {MediaCarouselFragment} from '@amblique/contentful/app/contentful/fragments/media-carousel/media-carousel.fragment';
import {RichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/rich-text-block.fragment';
import {SectionPanelFragment} from '@amblique/contentful/app/contentful/fragments/section-panel/section-panel.fragment';
import {TeaserTileFragment} from '@amblique/contentful/app/contentful/fragments/teaser-tile/teaser-tile.fragment';

export const FullSectionPanelAldrinFragment = gql`
  ${AccordionFragment}
  ${AccordionPanelFragment}
  ${ActionLinksFragment}
  ${BaseSectionPanelAldrinFragment}
  ${CarouselFragment}
  ${ContainerFragment}
  ${EmbedPanelFragment}
  ${FeatureListFragment}
  ${HeroBannerFragment}
  ${ImageFragment}
  ${LinkFragment}
  ${MediaCarouselFragment}
  ${RichTextBlockFragment}
  ${SectionPanelFragment}
  ${TeaserTileFragment}

  fragment FullSectionPanelAldrinFragment on SectionPanelAldrin {
    ...BaseSectionPanelAldrinFragment

    contentCollection {
      items {
        __typename
        ... on Accordion {
          ...AccordionFragment
        }
        ... on AccordionPanel {
          ...AccordionPanelFragment
        }
        ... on ActionLinks {
          ...ActionLinksFragment
        }
        ... on Carousel {
          ...CarouselFragment
        }
        ... on Container {
          ...ContainerFragment
        }
        ... on EmbedPanel {
          ...EmbedPanelFragment
        }
        ... on FeatureList {
          ...FeatureListFragment
        }
        ... on HeroBanner {
          ...HeroBannerFragment
        }
        ... on Image {
          ...ImageFragment
        }
        ... on Link {
          ...LinkFragment
        }
        ... on MediaCarousel {
          ...MediaCarouselFragment
        }
        ... on RichTextBlock {
          ...RichTextBlockFragment
        }
        ... on SectionPanel {
          ...SectionPanelFragment
        }
        ... on TeaserTile {
          ...TeaserTileFragment
        }
      }
    }
  }
`;
